/**
 * BG コードの形式 (spec AC-OMB-002): 区分 G/L/D いずれも 2 文字目=英字、
 * 3〜4 文字目=英数字で I / O を除外、末尾=エリアコード数字。backend
 * `valueobject.ParseBgCode` と同じ体系。
 *
 * BG マスタの入力検証 (bgCodeSchema) と、同時同量 需要詳細の URL・保存値の検証が
 * 同じ定義を使う。判定式を画面ごとに持つと片方だけ直して乖離する (issue #6279)。
 */
export const BG_CODE_FORMAT = /^[GLD][A-HJ-NP-Z][A-HJ-NP-Z0-9]{2}\d$/
